import { AxiosRequestConfig } from 'axios'
import packageJson from '../../../package.json'

const env = process.env.TARGET_ENV

const APP_FULL_NAME = `${packageJson?.name}_v${packageJson?.version}_${env}` ?? ''
export const addAppNameToHeader = (config: AxiosRequestConfig) => {
  if (config.headers) {
    config.headers['x-app-name'] = APP_FULL_NAME
  }

  return config
}
